module.exports = __webpack_public_path__ + "static/img/LionKing.c4653697.jpg";